import { IBwaIoGateway } from "./ioGateway";
import axios from "axios";

const createRuntimeIoGateway = (): IBwaIoGateway => ({
  axios,
  changeLocation: (newLocation: string) => window.location.replace(newLocation),
  getLocation: () => window.location.href,
});

export default createRuntimeIoGateway;
